var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main-container com-min-width",attrs:{"id":"mainContainer"}},[_c('el-container',[_c('el-header',{attrs:{"height":"8vh"}},[(!_vm.noHeader)?_c('Header'):_vm._e()],1),_c('el-container',[_c('el-aside',{attrs:{"width":"2rem"}},[_c('AsideMenu')],1),_c('el-main',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }